import {
  MOBILE_HEADER_WITH_GAP_HEIGHT,
  SMALL_DESKTOP_SIZE_BREAKPOINT
} from 'consts'
import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { AiContentLoading } from '../AiImageContent/components/AiContentLoading'
import { COLORS } from 'consts/colors'

/* The panel's shared content gutter — the inset every field, button and the tab
   row line up on (the AI Image panel uses the same 16px). */
const PANEL_GUTTER = 16

/* The container's horizontal padding is deliberately ASYMMETRIC: the tab
   content adds its own 14px through the scrollbar-gutter trick
   (`width: calc(100% + 28px)` + `padding-inline: 14px` in GenerateTabContainer /
   HistoryContainer), so a 2px left padding is what lands that content on
   PANEL_GUTTER. Don't "even these out" — it would push the content to 30px. */
const CONTAINER_PADDING_LEFT = 2
const CONTAINER_PADDING_RIGHT = PANEL_GUTTER

export const AIVideoContentContainer = styled.div<{
  $hasSelectedItem?: boolean
}>`
  padding: ${({ $hasSelectedItem }) => ($hasSelectedItem ? '24px' : '0')}
    ${CONTAINER_PADDING_RIGHT}px 0;
  padding-left: ${CONTAINER_PADDING_LEFT}px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: white;
  border-top-left-radius: 26px;
  border-top-right-radius: 26px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow-x: hidden;
  }
`
export const AIVideoContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 150px);
  width: 100%;
  flex: 1;
  padding-right: 14px;

  ${customizeVerticalScrollbarThumbMixin()}
`
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: calc(100dvh - ${MOBILE_HEADER_WITH_GAP_HEIGHT}px);
    overflow-y: auto;
  }
`

export const AiContentLoadingWrapper = styled(AiContentLoading)`
  margin: 20px 0;
`

export const StickyTabbarWrapper = styled.div`
  /* Unlike the tab content, the row has no wrapper contributing the extra 14px,
     so it makes up the difference to PANEL_GUTTER itself. Without this it starts
     at the container's bare 2px while everything below it starts at 16px. */
  margin-left: ${PANEL_GUTTER - CONTAINER_PADDING_LEFT}px;

  /* The segmented switcher has no bottom rule of its own (the old underline
     Tabbar did), so it needs its own separation from the tab content. */
  margin-bottom: 8px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    position: sticky;
    top: 0;
    z-index: 10;
    background: ${COLORS.white};
    /* Bleed the white background to the panel's edges — each side by its own
       padding, since the container's padding is asymmetric — then re-inset the
       row to PANEL_GUTTER. */
    margin: 0 -${CONTAINER_PADDING_RIGHT}px 0 -${CONTAINER_PADDING_LEFT}px;
    /* The full-bleed margin resets margin-bottom, so the separation is padding
       here — that also keeps it under the sticky white background. */
    padding: 0 ${PANEL_GUTTER}px 8px;
  }
`
